import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

export const buildRichTextLink = (url, label = 'Read Full Article') => ({
  nodeType: 'paragraph',
  content: [
    { nodeType: 'text', value: '', marks: [], data: {} },
    {
      nodeType: 'hyperlink',
      content: [{ nodeType: 'text', value: label, marks: [], data: {} }],
      data: { uri: url },
      shouldTriggerRemindMe: true,
    },
    { nodeType: 'text', value: '', marks: [], data: {} },
  ],
  data: {},
});

export const getBlogType = data => {
  const hasEditor = !_isEmpty(_get(data, 'editors.0.fields'));
  const hasPerson = !_isEmpty(_get(data, 'person.0.fields'));
  let blogType;
  if ((hasPerson && hasEditor) || hasPerson) {
    blogType = 'guest';
  } else if (hasEditor) {
    blogType = 'cm';
  }
  return blogType;
};

export const getResourceTags = resource => {
  const audiences = _get(resource, 'fields.audience');
  const highlights = _get(resource, 'fields.highlights');
  const tags = _get(resource, 'fields.tags');
  const fullTags = [];
  if (!_isEmpty(audiences))
    audiences.forEach(audience => {
      if (_get(audience, 'fields.reviewStatus') === 'Accepted')
        fullTags.push(
          _get(audience, 'fields.longName') || _get(audience, 'fields.name'),
        );
    });
  if (!_isEmpty(tags))
    tags.forEach(tag => {
      if (_get(tag, 'fields.reviewStatus') === 'Accepted')
        fullTags.push(
          _get(tag, 'fields.longName') || _get(tag, 'fields.title'),
        );
    });
  if (highlights) highlights.forEach(el => fullTags.push(el));

  return fullTags;
};

export const getResourceFields = resource => {
  let linkUrl = '/404';
  let name = _get(resource, 'fields.title');
  let description = _get(resource, 'fields.shortDescription');

  const slug = _get(resource, 'fields.slug');

  const type = _get(
    resource,
    'sys.contentType.sys.id',
    _get(resource, 'fields.type'),
  );

  if (type === 'Lists' || type === 'lists' || type === 'list') {
    linkUrl = `/lists/${slug}`;
  }
  if (type === 'Videos' || type === 'video') {
    linkUrl = `/videos/${slug}`;
    name = _get(resource, 'fields.title');
  }
  if (type === 'Apps' || type === 'application') {
    linkUrl = `/apps/${slug}`;
    name = _get(resource, 'fields.name');
  }
  if (
    type === 'Podcasts' ||
    type === 'podcast' ||
    type === 'Episode' ||
    type === 'episode'
  ) {
    linkUrl = `/podcasts/${slug}`;
    name = _get(resource, 'fields.title');
  }
  if (type === 'People' || type === 'person') {
    linkUrl = `/people/${slug}`;
    name = _get(resource, 'fields.name');
  }
  if (type === 'Books' || type === 'book') {
    linkUrl = `/books/${slug}`;
    const title = _get(resource, 'fields.title', '');
    const bookTitleArr = title.split(':');
    name = title;

    if (bookTitleArr.length >= 2) {
      const [_title, ...subtitle] = bookTitleArr;
      name = _title;
      description = subtitle.join(' ').trim();
    }
  }
  if (type === 'Articles' || type === 'activity' || type === 'News') {
    linkUrl = `/articles/${slug}`;
    name = _get(resource, 'fields.name');
  }
  if (type === 'Insights' || type === 'Blogs') {
    linkUrl = `/insights/${slug}`;
  }
  if (type === 'Online Programs' || type === 'onlineProgram') {
    linkUrl = `/programs/${slug}`;
    name = _get(resource, 'fields.title');
  }
  if (type === 'Topics' || type === 'topics') {
    linkUrl = `/topics/${slug}`;
    name = _get(resource, 'fields.title');
  }
  if (type === 'series') {
    linkUrl = `/series/${slug}`;
    name = _get(resource, 'fields.title');
  }

  return {
    linkUrl,
    name,
    description,
    type,
  };
};

export const isResourceExcluded = (
  resource,
  clientExcludedTopicId,
  clientExcludedResourceTypesToken,
) => {
  if (_get(resource, 'fields.reviewStatus') !== 'Accepted') return true;

  const type = _get(
    resource,
    'sys.contentType.sys.id',
    _get(resource, 'fields.type'),
  );

  if (clientExcludedResourceTypesToken[type]) return true;

  const resourceTopicIds =
    type === 'Topics' || type === 'topics'
      ? [_get(resource, 'sys.id', '')]
      : _get(resource, 'fields.topics', []).map(({ sys }) => sys.id);

  if (resourceTopicIds.some(topicId => clientExcludedTopicId[topicId]))
    return true;

  return false;
};
